<style>
    @import '@/assets/css/custom.css';
    
    .hover-bg-light:hover {
        background-color: #f8f9fa !important;
    }
    
    .cursor-pointer {
        cursor: pointer;
    }
</style>

<template>
    <div>
        <Breadcrumbs main="Boards" title="Board Batches" />

        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="col-md-12 project-list filter-sort">
                                <div class="row">
                                    <div class="col-md-10 d-flex mt-2">
                                        <label class="d-flex listing-length ms-1"><span>Show</span>
                                            <select class="form-select" v-model="listing_length" @change="fetchBoards()">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                            </select>
                                            <span>entries</span>
                                        </label>
                                    </div>
                                    <div class="col-md-2 mt-2">
                                        <input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchBoards()"/>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive product-table">
                                <table class="display" id="basic-1">
                                    <thead>
                                        <tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Batch Number</th>
                                            <th>Staff Name</th>
                                            <th>Batch Status</th>
                                            <th>SIM Activation Status</th>
                                            <th>Total Boards</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="Boolean(boards.length)">
                                        <tr v-for="(board, index) in boards" :key="board.id" align="center">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ board.batch_number }}</td>
                                            <td>{{ board.staff_name }}</td>
                                            <td>
                                                <span v-if="board.status == 1">
                                                    <span class="badge rounded-pill bg-success">Active</span>
                                                </span>
                                                <span v-if="board.status == 2">
                                                    <span class="badge rounded-pill bg-secondary">Closed</span>
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="board.sim_activation_status == 1">
                                                    <span class="badge rounded-pill bg-warning">Pending</span>
                                                </span>
                                                <span v-if="board.sim_activation_status == 2">
                                                    <span class="badge rounded-pill bg-success">Completed</span>
                                                </span>
                                            </td>
                                            <td>{{ board.total_boards }}</td>
                                            <td>{{ $filters.formatDate(board.start_date) }}</td>
                                            <td>{{ board.end_date ? $filters.formatDate(board.end_date) : '-' }}</td>
                                            <td>
                                                <router-link :to="{ name: 'batch_details', params: { id: board.id } }" class="btn btn-primary btn-sm mt-1">
                                                    Details
                                                </router-link>

                                                <button 
                                                    class="btn btn-warning btn-sm mt-1 ms-2" 
                                                    @click="openSimActivateModal(board.id)"
                                                    :disabled="board.sim_activation_status === 2"
                                                    :class="{ 'btn-secondary': board.sim_activation_status === 2 }"
                                                >
                                                    SIM Activate
                                                </button>

                                                <button class="btn btn-info btn-sm ms-2 mt-1" @click="generateBarcode(board.id)" :disabled="loadingBarcodeBatchId === board.id">
                                                    <span v-if="loadingBarcodeBatchId === board.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    Barcode
                                                </button>
                                                <button class="btn btn-success btn-sm ms-2 mt-1" @click="downloadExcel(board.id, board.batch_number)" :disabled="loadingExcelBatchId === board.id">
                                                    <span v-if="loadingExcelBatchId === board.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    Excel
                                                </button>
                                                <button class="btn btn-secondary btn-sm ms-2 mt-1" @click="downloadTxt(board.id, board.batch_number)" :disabled="loadingTxtBatchId === board.id">
                                                    <span v-if="loadingTxtBatchId === board.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    VAHAN TXT
                                                </button>

                                                <button 
                                                    class="btn btn-secondary btn-sm mt-1 ms-2" 
                                                    @click="openEnclosureModal(board.id)"
                                                    :disabled="board.enclosure_status === 1"
                                                    :class="{ 'btn-secondary': board.enclosure_status === 2 }"
                                                >
                                                    Enclosure
                                                </button>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="9" align="center">No data available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!----pagination starts --->
                            <caption v-if="Boolean(boards.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
                            <nav aria-label="Page navigation" class="mt-2 float-end">
                                <ul class="pagination">
                                    <li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
                                        <a class="page-link" href="#" @click.prevent="fetchBoards(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
                                            <span v-if="index == 0">Prev</span>
                                            <span v-else-if="index == pagination.length - 1">Next</span>
                                            <span v-else>{{ page.label }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            <!----pagination ends --->
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SIM Activate Modal -->
        <div class="modal fade" id="simActivateModal" tabindex="-1" aria-labelledby="simActivateModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="simActivateModalLabel">SIM Activation</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="submitSimActivation" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-12 form-group mt-2">
                                    <label class="control-label">Activation Date<span class="text-danger">*</span></label>
                                    <input 
                                        v-model="activationDate" 
                                        type="date" 
                                        class="form-control" 
                                        required
                                    />
                                    <span v-if="errors.activation_date" class="text-danger small">{{ errors.activation_date }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 form-group mt-3">
                                    <button type="submit" class="btn btn-primary me-3">Activate</button>
                                    <button type="button" class="btn btn-light" @click="closeSimActivateModal">Close</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Board Modal -->
        <div class="modal fade" id="addBoardModal" tabindex="-1" aria-labelledby="addBoardModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addBoardModalLabel">Add Board</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addBoard" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-12 form-group mt-2">
                                    <label class="control-label">Vendor<span class="text-danger">*</span></label>
                                    <select v-model="newBoard.vendor" class="form-select" required>
                                        <option value="">Select Vendor</option>
                                        <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
                                            {{ vendor.name }}
                                        </option>
                                    </select>
                                    <span v-if="errors.vendor" class="text-danger small">{{ errors.vendor }}</span>
                                </div>
                                <div class="col-md-12 form-group mt-2">
                                    <label class="control-label">Count<span class="text-danger">*</span></label>
                                    <input v-model="newBoard.count" type="number" class="form-control" min="1" max="100" placeholder="Enter count" required />
                                    <span v-if="errors.count" class="text-danger small">{{ errors.count }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 form-group mt-3">
                                    <button type="submit" class="btn btn-primary me-3">Save Board</button>
                                    <button type="button" class="btn btn-light" @click="closeAddBoardModal">Close</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {Modal} from "bootstrap"

    export default {
        name: "Board Batches",

        data() {
            return {
                keyword: "",
                listing_length: 10,
                token: "",
                errors: {},
                loading: false,
                newBoard: {
                    vendor: "",
                    count: "",
                },
                vendors: [],
                boards: [],
                pagination: {},
                from: 0,
                to: 0,
                total: 0,
                selectedBatchId: null,
                activationDate: "",
                loadingBarcodeBatchId: null,
                loadingExcelBatchId: null,
                loadingTxtBatchId: null,
            };
        },
        created() {
            this.fetchBoards();
            this.fetchVendors();
        },
        methods: {

            getToken() {
                if (localStorage.getItem('airotrack_staff')) {
                    var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
                            
                    if(airotrack_staff.token) {

                        this.token = airotrack_staff.token;
                        this.user = airotrack_staff;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            },
            
            fetchBoards(page_url = null) {
                this.getToken();
                let url = "/staffs/batchBoardsList?limit=" + this.listing_length + "&keyword=" + this.keyword;
                page_url = page_url || url;
                this.active_page_url = page_url;
                this.$axios
                    .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.boards = responseData.batch_boards.data;
                        this.pagination = responseData.batch_boards.links;
                        this.from = responseData.batch_boards.from;
                        this.to = responseData.batch_boards.to;
                        this.total = responseData.batch_boards.total;
                        
                    })
                    .catch((err) => console.log(err));
            },

            fetchVendors() {
                this.getToken();
                this.$axios
                    .get("/staffs/vendorsList", { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data;
                        this.vendors = responseData.data;
                    })
                    .catch((err) => console.log(err));
            },

            // New Add Board Modal Methods
            openAddBoardModal() {
                this.clearAddBoardForm();
                const modal = new Modal(document.getElementById('addBoardModal'));
                modal.show();
            },

            closeAddBoardModal() {
                const modal = Modal.getInstance(document.getElementById('addBoardModal'));
                if (modal) {
                    modal.hide();
                }
            },

            clearAddBoardForm() {
                this.newBoard = {
                    vendor: "",
                    count: 1,
                    notes: ""
                };
                this.errors = {};
            },

            saveBoard() {
                // Reset errors
                this.errors = {};
                
                // Validation
                if (!this.newBoard.vendor) {
                    this.errors.vendor = "Vendor is required";
                }
                if (!this.newBoard.count || this.newBoard.count < 1) {
                    this.errors.count = "Count must be at least 1";
                }
                
                // If there are errors, don't proceed
                if (Object.keys(this.errors).length > 0) {
                    return;
                }
                
                // Here you would typically make an API call to save the board
                // For now, we'll just show a success message and close the modal
                this.$swal({
                    icon: 'success',
                    title: 'Success!',
                    text: `Board added successfully for vendor ID: ${this.newBoard.vendor} with count: ${this.newBoard.count}`,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    position: "center",
                    timer: '',
                    toast: false,
                }).then(() => {
                    this.closeAddBoardModal();
                    // Optionally refresh the boards list here
                    // this.fetchBoards();
                });
            },

            addBoard() {

                this.getToken();
                this.errors = {};

                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/addBoardData";  
                this.loading = true;

                let formData = new FormData();
                formData.append("vendor_id", this.newBoard.vendor);
                formData.append("count", this.newBoard.count);
                
                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.closeAddBoardModal();
                        this.clearForm();
                        this.fetchBoards();
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    });
            },

            clearForm() {
                this.errors = {};
                this.newBoard.count = "";
            },

            // SIM Activation Modal Methods
            openSimActivateModal(batchId) {
                this.selectedBatchId = batchId;
                this.activationDate = "";
                this.errors = {};
                const modal = new Modal(document.getElementById('simActivateModal'));
                modal.show();
            },

            closeSimActivateModal() {
                const modal = Modal.getInstance(document.getElementById('simActivateModal'));
                if (modal) {
                    modal.hide();
                }
                this.selectedBatchId = null;
                this.activationDate = "";
                this.errors = {};
            },

            generateBarcode(batchId) {
                this.getToken();
                this.loadingBarcodeBatchId = batchId;
                const url = "/staffs/batchwiseBarcode?batch_id=" + encodeURIComponent(batchId);
                this.$axios
                    .get(url, {
                        headers: { Authorization: "Bearer " + this.token },
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        // Check for JSON error response (small response)
                        if (response.data.byteLength < 1000) {
                            try {
                                const decoder = new TextDecoder("utf-8");
                                const jsonString = decoder.decode(response.data);
                                if (jsonString.trim().startsWith("{")) {
                                    const jsonResponse = JSON.parse(jsonString);
                                    if (jsonResponse.status === false || jsonResponse.status === "false") {
                                        this.$swal("", jsonResponse.message || "Failed to generate barcode", "error");
                                        return;
                                    }
                                }
                            } catch (e) {
                                // not JSON, continue
                            }
                        }
                        const blob = new Blob([response.data], { type: "application/pdf" });
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = "barcode_batch_" + batchId + ".pdf";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl);
                        this.$swal("", "Barcode PDF downloaded successfully", "success");
                    })
                    .catch((err) => {
                        let errorMessage = "Failed to download barcode PDF";
                        if (err.response && err.response.data) {
                            try {
                                if (err.response.data instanceof ArrayBuffer) {
                                    const decoder = new TextDecoder("utf-8");
                                    const jsonString = decoder.decode(err.response.data);
                                    const jsonResponse = JSON.parse(jsonString);
                                    errorMessage = jsonResponse.message || errorMessage;
                                } else if (typeof err.response.data === "object" && err.response.data.message) {
                                    errorMessage = err.response.data.message;
                                }
                            } catch (e) {
                                // use default
                            }
                        }
                        this.$swal("", errorMessage, "error");
                    })
                    .finally(() => {
                        this.loadingBarcodeBatchId = null;
                    });
            },

            downloadExcel(batchId, batchNumber) {
                this.getToken();
                this.loadingExcelBatchId = batchId;
                const url = "/staffs/batchwiseBoardDataExcel?batch_id=" + encodeURIComponent(batchId);
                this.$axios
                    .get(url, {
                        headers: { Authorization: "Bearer " + this.token },
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        if (response.data.byteLength < 1000) {
                            try {
                                const decoder = new TextDecoder("utf-8");
                                const jsonString = decoder.decode(response.data);
                                if (jsonString.trim().startsWith("{")) {
                                    const jsonResponse = JSON.parse(jsonString);
                                    if (jsonResponse.status === false || jsonResponse.status === "false") {
                                        this.$swal("", jsonResponse.message || "Failed to download Excel", "error");
                                        return;
                                    }
                                }
                            } catch (e) {}
                        }
                        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = (batchNumber || batchId) + "_boards.xlsx";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl);
                        this.$swal("", "Excel downloaded successfully", "success");
                    })
                    .catch((err) => {
                        let errorMessage = "Failed to download Excel";
                        if (err.response && err.response.data) {
                            try {
                                if (err.response.data instanceof ArrayBuffer) {
                                    const decoder = new TextDecoder("utf-8");
                                    const jsonString = decoder.decode(err.response.data);
                                    const jsonResponse = JSON.parse(jsonString);
                                    errorMessage = jsonResponse.message || errorMessage;
                                } else if (typeof err.response.data === "object" && err.response.data.message) {
                                    errorMessage = err.response.data.message;
                                }
                            } catch (e) {}
                        }
                        this.$swal("", errorMessage, "error");
                    })
                    .finally(() => {
                        this.loadingExcelBatchId = null;
                    });
            },

            downloadTxt(batchId, batchNumber) {
                this.getToken();
                this.loadingTxtBatchId = batchId;
                const url = "/staffs/batchwiseBoardTxt?batch_id=" + encodeURIComponent(batchId);
                this.$axios
                    .get(url, {
                        headers: { Authorization: "Bearer " + this.token },
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        const contentType = response.headers["content-type"] || "";
                        if (contentType.includes("application/json")) {
                            const jsonResponse = JSON.parse(new TextDecoder("utf-8").decode(response.data));
                            this.$swal("", jsonResponse.message || "Failed to download text file", "error");
                            return;
                        }
                        const blob = new Blob([response.data], { type: "text/plain;charset=utf-8" });
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = (batchNumber || batchId) + "_boards.txt";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch((err) => {
                        let errorMessage = "Failed to download text file";
                        if (err.response && err.response.data instanceof ArrayBuffer) {
                            try {
                                const jsonResponse = JSON.parse(new TextDecoder("utf-8").decode(err.response.data));
                                errorMessage = jsonResponse.message || errorMessage;
                            } catch (e) {}
                        }
                        this.$swal("", errorMessage, "error");
                    })
                    .finally(() => {
                        this.loadingTxtBatchId = null;
                    });
            },

            submitSimActivation() {
                this.getToken();
                this.errors = {};

                if (!this.activationDate) {
                    this.errors.activation_date = "Activation date is required";
                    return;
                }

                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/activateSim";
                this.loading = true;

                let formData = new FormData();
                formData.append("batch_id", this.selectedBatchId);
                formData.append("date", this.activationDate);

                this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                            this.closeSimActivateModal();
                            this.fetchBoards();
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loading = false;
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    });
            },

            openEnclosureModal(batch_id) {
                this.$swal({
                    icon: 'warning',
                    title: "Confirm",
                    text: 'Are you sure you want to complete enclosure for this batch?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonColor: '#e64942',
                    cancelButtonText: 'No',
                    position: "center",
                    showConfirmButton: true,
                    timer: '',
                    toast: false,
                    cancelButtonColor: '#efefef',
                }).then((result) => {
                    if (result.value) {
                        this.selectedBatchId = batch_id;
                        this.enclosure();
                    }
                });
            },

            enclosure() {
                this.getToken();
                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        Authorization: "Bearer " + this.token,
                    },
                };
                let url = "staffs/batchEnclosure";
                let formData = new FormData();
                formData.append("batch_id", this.selectedBatchId);

                this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        const ok = response.data.status === true || response.data.status === "true";
                        if (ok) {
                            this.$swal("", response.data.message || "Batch enclosure completed successfully", "success");
                        } else {
                            this.$swal("", response.data.message || "Failed to complete enclosure", "error");
                        }
                        this.fetchBoards(this.active_page_url);
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.data.message) {
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    });
            },

        },
    };
</script>